module.exports = "https://www.gc-qa.gnp.com.mx/fcce3738833246e4b9fbb4447500f0ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/otp/1.png
// module id = 1036
// module chunks = 0 1